// extracted by mini-css-extract-plugin
export default {"root":"_1VR-r","dd":"_2hvJS","hype":"FjJ_Q"};